import React, { useContext, useRef } from 'react'
import styles from './WorkingStatus.module.css'
import { StepContext } from '@/components/Context/StepContext'
import { TileButton } from '../../../Common/CtaButton/TileButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { WorkingStatusProps } from './types'
import { useAbTestGtm } from '@/components/utils/abTest'
import { FollowIcon } from '../../../FormGuidance/FollowIcon'
import { useFollowIcon } from '../../../FormGuidance/FollowIcon/useFollowIcon'

export const WorkingStatus = ({ gtmTags, onBack }: WorkingStatusProps) => {
    const { handleNext, updateFormData, formData, isCurrentStepValid, isAnimating, currentStep } = useContext(StepContext)

    const parentRef = useRef<HTMLDivElement>(null)
    const questionRef = useRef<HTMLDivElement>(null)
    const tileAreaRef = useRef<HTMLDivElement>(null)
    const targets = [
        { ref: questionRef, isComplete: false },
        { ref: tileAreaRef, isComplete: isCurrentStepValid },
    ]
    const { iconStyle } = useFollowIcon({
        parentRef,
        targets,
        isAnimating,
        layoutKey: currentStep,
    })

    const handleSelect = (status) => {
        updateFormData('workingStatus', status)
        handleNext()
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div
            className={styles.wrapper}
            ref={parentRef}
            data-view-label={dataViewLabel(gtmTags.dataViewLabel)}
        >
            <FollowIcon iconStyle={iconStyle} />

            <div
                className={styles.title}
                ref={questionRef}
            >
                {onBack && (
                    <BackButton
                        dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.back)}
                        onClick={onBack}
                    />
                )}
                <h2
                    className={styles.titleText}
                >
                    Q.現在の状況はいかがですか？
                </h2>
            </div>
            <div
                className={styles.selectionWrapper}
                ref={tileAreaRef}
            >
                <TileButton
                    onClick={() => handleSelect('就業中')}
                    buttonText={'就業中'}
                    imageSrc={'/entry_form_slide_app/steps/step1/frypan.png'}
                    imageAlt={'就業中アイコン'}
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.working)}
                    selected={formData.workingStatus === '就業中'}
                />
                <TileButton
                    onClick={() => handleSelect('離職中')}
                    buttonText={'離職中'}
                    imageSrc={'/entry_form_slide_app/steps/step1/bed.png'}
                    imageAlt={'離職中アイコン'}
                    dataClickLabel={dataClickLabel(gtmTags.dataClickLabels.unemployed)}
                    selected={formData.workingStatus === '離職中'}
                />
            </div>
        </div>
    )
}
